import React from 'react';
import PropTypes from 'prop-types';

const InfoGeneric = ({
    title,
    subtitle
}) => {
    return (
        <div className="SH-InfoGeneric">
            {title &&
                <h1 className="heading-sm">{title}</h1>
            }
            {subtitle &&
                <p>{subtitle}</p>
            }
        </div>
    );
};

InfoGeneric.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string
};

export default InfoGeneric;



// WEBPACK FOOTER //
// ./widget/src/js/components/header/InfoGeneric.jsx